import TwoColumnCarousel from './TwoColumnCarousel'


export default TwoColumnCarousel
